<template>
  <footer class="footer">
    <v-row>
      <v-col cols="12" md="3">
        <img
          src="@/assets/cobredelmayo-gris.svg"
          alt=""
          width="225.005"
          height="83.599"
        />
      </v-col>
      <v-col cols="12" md="8">
        <v-row class="footer-divider">
          <v-col cols="12" md="4">
            <p class="p-footer">{{ companyName }}</p>
          </v-col>
          <v-col cols="12" md="4">
            <p class="p-footer">{{ email }}</p>
          </v-col>
          <v-col cols="12" md="4">
            <p class="p-footer">{{ copyright }} {{ year }}.</p>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="1"></v-col>
    </v-row>
  </footer>
</template>

<script>
import { ref } from "vue";

export default {
  name: "FooterComponentCobre",
  setup() {
    // Definimos los datos del footer usando ref
    const companyName = ref("Cobre del Mayo, S.A. De C.V.");
    const email = ref("suppliers@cobredelmayo.com");
    const copyright = ref("© Cobre del Mayo");
    const year = new Date().getFullYear();

    return {
      companyName,
      email,
      copyright,
      year,
    };
  },
};
</script>

<style scoped>
.footer {
  background-color: white;
  color: black;
  padding: 20px 0;
  text-align: center;
  margin-top: auto;
  background-image: url("../assets/bg-footer-cobre.jpg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 25vh;
  width: 100%;
  margin-bottom: 0% !important;
}

.footer-divider {
  border-top: 2px solid #e4e5e5;
  margin-top: 3rem;
  margin-bottom: 3rem;
}

.p-footer {
  font-family: "Now";
  font-size: 0.7rem !important;
  font-weight: 600;
  margin: 0;
  color: #130c0e;
}
</style>
